module.exports = __webpack_public_path__ + "3f16e137/img/arrow-left-icon.785c715c.svg";